import { APIRequest, APIRequestDtoImpl } from '../apiRequest';
import { LoginDto } from '../../dto/login/logindto';


export interface LoginRequest extends APIRequest
{
    getLoginRequest(): LoginDto;
    getChannelId(): string;
}

export class LoginRequestImpl extends APIRequestDtoImpl implements LoginRequest
{
    constructor(private LoginData: LoginDto, private channelId: string)
    {
        super();
    }

    getLoginRequest(): LoginDto
    {
        return this.LoginData;
    }

    getChannelId(): string {
        return this.channelId;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/login/loginrequest.tsx